import React from 'react';

import { LoginCallback } from '@okta/okta-react';
import { useNavigate, useRoutes } from 'react-router-dom';
import useScrollToTop from '../hooks/useScrollToTop';
import AuthGuard from '../gaurds/AuthGuard';
import DashboardLayout from '../layouts/Dashboard';
import Dashboard from './Dashboard';
import VehicleV1 from './VehicleV1';
import VehicleV2 from './VehicleV2';
import Vehicles from './Vehicles';
import Inventory from './Inventory';
import InventoryNew from './InventoryNew';
import Logout from './Logout';
import Assignment from './Assignment';
import Search from './Search';
import Error from './Error';
import { PermissionsGuard } from '../gaurds/PermissionsGuard';

const Routes = () => {
  useScrollToTop();

  return useRoutes([
    {
      path: 'v360-app',
      children: [
        {
          path: 'login/callback',
          element: <LoginCallback errorComponent={Error} />,
        },
        {
          path: 'logout',
          element: <Logout />,
        },
        {
          path: '',
          element: (
            <AuthGuard>
              <DashboardLayout />
            </AuthGuard>
          ),
          children: [
            // { path: '', element: <Dashboard />, index: true },
            { path: '', element: <Search />, index: true },
            {
              path: 'vehicles',
              element: <Vehicles />,
              children: [
                {
                  path: 'change-history',
                  element: <Vehicles />,
                },
              ],
            },
            {
              path: 'inventory',
              element: (
                <PermissionsGuard permissions={['ACCESS_INVENTORY_PAGE']}>
                  <InventoryNew />
                </PermissionsGuard>
              ),
              children: [
                {
                  path: 'my-requests',
                  element: (
                    <PermissionsGuard permissions={['ACCESS_INVENTORY_PAGE']}>
                      <InventoryNew />
                    </PermissionsGuard>
                  ),
                },
              ],
            },
            { path: 'vehiclesv1/:reservationId', element: <VehicleV1 /> },
            { path: 'vehicles/:reservationId', element: <VehicleV2 /> },
            {
              path: 'assignment',
              element: (
                <PermissionsGuard permissions={['ACCESS_ASSIGNMENT_PAGE']}>
                  <Assignment />
                </PermissionsGuard>
              ),
              children: [
                {
                  path: 'approved',
                  element: <Assignment />,
                },
                {
                  path: 'rejected',
                  element: <Assignment />,
                },
                {
                  path: 'on-hold',
                  element: <Assignment />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: '*',
      element: <div>404 not found</div>,
    },
  ]);
};

export default Routes;
